<template>
  <div>
    <div class="footerBar infoFooter">
        <div class="f-c-head">
          <div class="content head-content">
            <div class="logo">
              <img src="../assets/images/logo@2x.png" style="width: 120px;" alt="" v-if="home">
              <h3 v-else>{{ $t('market_12') }}</h3>
            </div>
            <div class="source">
              <a class="footer_gp" href="https://play.google.com/store/apps/details?id=com.wtmob.app" target="_blank">
                <img src="../assets/images/GooglePlayOp@2x.png" style="width: 140px; margin-right: 18px;" alt="">
              </a>
              <a class="footer_as" href="https://apps.apple.com/in/app/wetrade-market-data-and-news/id1604139836" target="_blank">
                <img src="../assets/images/AppStoreOp@2x.png" style="width: 140px; margin-right: 18px;" alt="">
              </a>
              <a class="footer_web" href="https://webtrader.wetrade.one/" target="_blank">
                <img src="../assets/images/WebOp@2x.png" style="width: 300px" alt="">
              </a>
            </div>
          </div>
        </div>
        <div class="content p-wrap">
          <div class="p-item">
            <h4>{{$t('home_68')}}</h4>
            <p>{{$t('home_69')}}</p>
          </div>
          <div class="p-item">
            <h4>{{$t('home_70')}}</h4>
            <p>{{$t('home_71')}}</p>
          </div>
          <div class="p-item">
            <h4>{{$t('home_72')}}</h4>
            <p>{{$t('home_73')}}</p>
          </div>
        </div>
      </div>
    <div class="footerBar">
      <div class="content">
        <div class="main footerLogo">
          <div class="logword">{{$t('home_74')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerBar",
  props: {
    home: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style scoped lang="scss">
.footerBar {
  background: #010012;
  color: #5C6E7B;
}
.f-c-head{
  border-bottom: 1px solid #2D343E;
  .head-content{
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo{
      h3{
        font-size: 32px;
        font-family: Roboto-Bold, Roboto;
        font-weight: bold;
        color: #326BFE;
        line-height: 38px;
      }
    }
  }
}
.p-wrap{
  display: flex;
  padding: 30px 0 44px;
  color: #A1AEB6;
  .p-item{
    flex: 1;
    padding-right: 40px;
    h4{
      font-size: 16px;
      flex-wrap: bolder;
    }
    p{
      margin-top: 10px;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .p-item:nth-child(3){
    padding: 0;
  }
}
.infoFooter {
  background: rgba(1, 0, 18, 0.95);
}

.footerLogo {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #5C6E7B;
}
</style>



// WEBPACK FOOTER //
// src/components/footerBar.vue